import { httpRequest } from '@/clients/http'
import { local } from '@/db/repositories/local'
import * as shifts from '@/db/repositories/shifts'
import { configService } from '@/services/ConfigService'
import { PosModel } from '@/types'

export const RegisterModel = {
  getCurrent: () =>
    configService.isDemo()
      ? httpRequest<PosModel.Register>({ method: 'get', url: '/pos/register' })
      : local(shifts.getRegister()),
}
